<template>
  <div class="summary-outer-wrapper">
    <transition name="dropdownSlide">
      <dropdown
        v-if="team && sharedTeams.length > 1"
        :value="team.name"
        team
        :options="sharedTeams"
        :title="$t('team')"
        class="team-dropdown"
        @input="changeTeam"
      />
    </transition>
    <div class="section">
      <h4>{{ $t('workingTime') }}</h4>
      <div class="progress-value">
        <!-- <label>{{ $t('hours') }}</label> -->
        <p>{{ teamHourScheduleFormatted }}</p>
      </div>
      <ProgressBar
        :current="(team && hoursScheduled[team.teamId]) ? hoursScheduled[team.teamId] : 0"
        :total="(sharedTeams.length > 1) ? hoursScheduled.total : 40"
        :bar-type="'default'"
      />
      <div 
        v-if="sharedTeams.length > 1"
        class="progress-desc"
      >
        <p>{{ hourScheduleFormatted }} {{ $t('totalAcross') }}</p>
      </div>
    </div>

    <div
      class="section"
    >
      <h4>
        {{ $t('timeOff') }}
      </h4>

      <div class="progress-value">
        <p>{{ holidayRow }} {{ $t('holidaysPaid') }}</p>
      </div>
      <ProgressBar
        :current="holidaysUsed"
        :total="holidaysLimit"
        :bar-type="'holidays'"
      />
      <a 
        v-if="isMyPersonal && isNaN(holidaysLimit)"
        class="progress-desc link"
        @click="openHolidaysPopup"
      >
        {{ $t('whatIsYourAnnualLeave') }}
      </a>
    </div>
  </div>
</template>
<script>
import ProgressBar from '@/components/UI/ProgressBar'
import EventBus from '@/EventBus'
import moment from 'moment-timezone'
import Dropdown from '@/components/UI/Dropdown'

export default {
  components: {
    ProgressBar,
    Dropdown,
  },
  props: {
    hoursScheduled: {
      type: Object,
      default: function () { return {total: 0} },
    },
    holidayInfo: {
      type: Object,
      default: function () { return {} },
    },
    isMyPersonal: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      team: undefined,
    }
  },
  computed: {
    hourScheduleFormatted() {
      return this.formatHours(this.hoursScheduled.total)
    },
    teamHourScheduleFormatted() {
      if (!this.team || !this.holidayInfo[this.team.teamId]) return '0:00 hours'
      let teamHours = this.hoursScheduled[this.team.teamId] ? this.hoursScheduled[this.team.teamId] : 0
      return this.formatHours(teamHours)
    },
    holidaysUsed() {
      if (!this.team || !this.holidayInfo[this.team.teamId]) return 0
      let tempTimeOff = this.$store.state.tempTimeOffChanges[this.team.teamId] || 0
      return this.holidayInfo[this.team.teamId][moment().format('YYYY')].used + tempTimeOff
    },
    holidaysLimit() {
      if (!this.team || !this.holidayInfo[this.team.teamId]) return null
      return this.holidayInfo[this.team.teamId][moment().format('YYYY')].limit
    },
    holidayRow() {
      if (this.holidaysLimit !== null && this.holidaysLimit >= 0)
        return this.holidaysUsed + '/' + this.holidaysLimit
      return this.holidaysUsed
    },
    sharedTeams() {
      if (Object.keys(this.holidayInfo) == 0) return []
      return this.$store.state.teams.filter(team => {
        return this.holidayInfo[team.teamId] != undefined
      })
    }
  },
  watch: {
    holidayInfo: function() {
      if (this.team && this.holidayInfo.length) {
        this.team = this.$store.state.teams.find(x=>x.teamId === Object.keys(this.holidayInfo)[0])
      }
    },
  },
  created() {
    let teamId
    if (this.$route.query && this.$route.query.teamId) {
      teamId = this.$route.query.teamId
    } else {
      teamId = Object.keys(this.holidayInfo)[0]
    }
    this.team = this.$store.state.teams.find(x=>x.teamId === teamId)
  },
  methods:{
    formatHours(input){
      let hours = Math.floor(input)
      let minutes = Math.floor((input % 1) * 60)
      minutes = minutes.toString()
      if(minutes.length === 1){
        minutes = '0' + minutes
      }
      return hours + ':'+ minutes + ' ' + this.$tc('hoursPlural',hours)
    },
    openHolidaysPopup(){
      let force = true
      EventBus.$emit('open-holidays-popup', this.team.teamId, force)
    },
    changeTeam(e){
      this.team = this.$store.state.teams.find(x=> x.name === e)
    },
    setTeam(team) {
      this.team = team
    }
  },
}
</script>
<style lang="scss" scoped>
.summary-outer-wrapper {
  flex: 1;
  max-width: 300px;
  height: 100%;
  padding: 24px 20px;
  border-left: 1px solid $athens-gray;
  background-color: white;
  z-index: 5;
  overflow-y: auto;
  @include respond-below(md) {
    display: none; // for now the right-bar is hidden
  }
  h4 {
    font-size: 18px;
    margin-bottom: 24px;
    text-transform: capitalize;
  }
  .team-dropdown {
    margin-bottom: 36px;
  }
  .progress-value {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    
    margin-bottom: 6px;
    // text-transform: capitalize;
  }
  .progress-desc {
    display: flex;
    font-size: 14px;
    color: $bluebell;
    margin-top: 9px;
    // text-transform: capitalize;
  }
  .link {
    cursor: pointer;
    color: $blue;
    text-transform: initial;
    &:hover {
      color: $darkest-blue;
    }
  }
  .section {
    margin-bottom: 48px;
    
  }
  
  .dropdownSlide-enter,
  .dropdownSlide-leave-to {
    transform: translateY(-100%);
    opacity: 0;
    margin-bottom: 0;
    max-height: 0;
  }
  .dropdownSlide-leave,
  .dropdownSlide-enter-to{
    transform: translateY(0);
    opacity: 1;
    margin-bottom: 36px;
    max-height: 100%;
  }

  .dropdownSlide-enter-active,
  .dropdownSlide-leave-active {
    transition: all 0.3s ease-in;
  }
}
</style>
